import React, { useEffect, useState } from 'react';
// import { useHistory } from "react-router-dom";
import StoreHeading from '../../components/StoreHeading'
import LoadingComponent from '../../components/loading-component';
import { obtenerListaMascota } from '../../api/api-mascota';
import MascotaCardComponent from '../../components/mascota-card-componenet';
import Select from "react-select";
import { obtenerDepartamentos } from '../../api/api-departamento';
import ColaboradoresCard from '../../components/colaboradores-card-component';
import { obtenerRefugios } from '../../api/api-refugio';
import shortid from 'shortid';
import VerticalAd from '../../components/vertical-ad';
import BottomAd from '../../components/bottom-ad';

export default function LandingScreen() {

    // const history = useHistory();
    const [modalLoadingVisible, setModalLoadingVisible] = useState(false);
    const [listaColaboradores, setListaColaboradores] = useState([]);
    const [listaMascotas, setListaMascotas] = useState([]);
    const [listaDepartamentos, setListaDepartamentos] = useState([]);
    const [departamentoSelected, setdepartamentoSelected] = useState(null);

    const [publicidadDerecha, setPublicidadDerecha] = useState([]);
    const [publicidadIzquierda, setPublicidadIzquierda] = useState([]);
    const [publicidadInferior, setPublicidadInferior] = useState([]);

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            setModalLoadingVisible(true);
            const lista = await obtenerListaMascota({ idDepartamento: departamentoSelected !== null ? departamentoSelected.value : null });
            // console.log('lista', lista);
            if (lista.error === false) {
                setListaMascotas(lista.body);
            }
            const response = await obtenerDepartamentos();
            // console.log('response');
            // console.log(response);
            setListaDepartamentos(response.body);
            setModalLoadingVisible(false);
            obtenerColaboradores();
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
            setModalLoadingVisible(false);
        }
    };

    const search = async () => {
        iniciar();
    };

    const obtenerColaboradores = async () => {
        try {
            const response = await obtenerRefugios();
            // console.log('response refugios', response);
            if (response.error === false) {
                setListaColaboradores(response.body);
            }
        } catch (err) {
            console.log('obtenerColaboradores err');
            console.log(err);
        }
    };

    const render = () => {
        try {
            return (
                <div className="flex flex-col h-screen">
                    <div className="flex flex-grow overflow-hidden lg:pb-0 pb-[120px]">
                        {/* Left Ad (only visible on lg and xl) */}
                        <div className="hidden lg:block w-1/6 bg-white">
                            {/* <div className="h-full flex items-center justify-center">Ad Space</div> */}
                            <VerticalAd />
                        </div>

                        {/* Main Content (centered) */}
                        <main className="w-full lg:w-4/6 mx-auto p-4 overflow-y-auto h-full">
                            <StoreHeading />
                            <br />

                            <div className='flex flex-row justify-between'>
                                <div>
                                    <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="departamento">
                                        Departamento<span className="text-red-500">*</span>
                                    </label>
                                    <Select
                                        options={listaDepartamentos}
                                        isSearchable={true}
                                        isClearable={true}
                                        value={departamentoSelected}
                                        onChange={(event) => { setdepartamentoSelected(event); }}
                                        placeholder={"Seleccione Departamento"}
                                        className="w-full"
                                        menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                                    />
                                </div>
                                <div>
                                    <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="departamento">
                                        &nbsp;
                                    </label>
                                    <button className="px-6 py-2 text-white bg-blue-600 hover:bg-blue-700 font-semibold rounded-lg shadow-md transition duration-300"
                                        onClick={() => { search(); }}
                                    >
                                        Buscar
                                    </button>
                                </div>
                            </div>

                            <br />
                            <div className="flex flex-wrap">
                                {listaMascotas.map((mascota, index) => (
                                    <MascotaCardComponent key={index} mascota={mascota} />
                                ))}
                            </div>
                            <hr />
                            <br />
                            <label className="font-bold text-lg">Nuestros Colaboradores</label>
                            <div className="flex flex-wrap">
                                {listaColaboradores.map((data) => (
                                    <ColaboradoresCard key={shortid.generate()} refugio={data} />
                                ))}
                            </div>
                            <hr />
                            <br />
                            <div>
                                <label className="font-bold text-lg">Publicidad?</label>
                                <p>
                                    Comuníquese con nosotros en{" "}
                                    <a
                                        href="https://api.whatsapp.com/send/?phone=59176697125"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-500 underline hover:text-blue-700"
                                    >
                                        este enlace
                                    </a>
                                </p>

                            </div>
                            <hr />
                            <br />
                        </main>

                        {/* Right Ad (only visible on lg and xl) */}
                        <div className="hidden lg:block w-1/6 bg-white">
                            {/* <div className="h-full flex items-center justify-center">Ad Space</div> */}
                            <VerticalAd />
                        </div>

                        {/* Bottom Ad (only visible on md, sm, and xs) */}
                        <div className="lg:hidden w-full bg-gray-200 h-[120px] flex items-center fixed bottom-0">
                            {/* <div className="text-center w-full">Ad Space</div> */}
                            <BottomAd />
                            <div className="h-[8px]"></div>
                        </div>

                    </div>

                    <LoadingComponent
                        isOpen={modalLoadingVisible}
                    />
                </div>
            );
        } catch (err) {
            return (
                <label>Oopss</label>
            );
        }
    }

    return render();
}